import React from "react";
import { useState, useRef } from "react";
import {
    Box, Typography, Avatar, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener, MenuItem, FormControl,
    Link
} from "@mui/material";
import { FaUserCircle } from "react-icons/fa";
import { CiCalendar } from "react-icons/ci";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import CustomPagination from "components/CustomPagination";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { LuEye, LuRefreshCw } from "react-icons/lu";
import { useMemo } from "react";
import { BiListUl } from "react-icons/bi";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import Select from "react-select";
import WorkDetail from "../WorkDetail";

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

const DueList = ({ data = [] }) => {
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [open, setOpen] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const anchorRef = useRef(null);
    const [filters, setFilters] = useState({
        Priority: '',
        Status: '',
        DueDate: '',
        AssignedTo: ''
    });

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');

    const extractedPriority = Array.isArray(data) && data.length > 0
        ? [...new Set(data.map(item => item.priority).filter(Boolean))]
        : [];
    const workPriority = extractedPriority.map(category => ({
        value: category,
        label: category
    }));
    const extractedStatus = Array.isArray(data) && data.length > 0
        ? [...new Set(data.map(item => item.WorkflowStatus).filter(Boolean))]
        : [];
    const workStatus = extractedStatus.map(category => ({
        value: category,
        label: category
    }));

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = (filterType) => {
        setFilters(prev => ({
            ...prev,
            [filterType]: ''
        }));
    };

    const handleSelectChange = (selectedOption, filterType) => {
        const value = selectedOption ? selectedOption.value : '';
        setFilters(prev => ({
            ...prev,
            [filterType]: value
        }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleReset = () => {
        setFilters({
            Priority: '',
            Status: '',
            DueDate: '',
            AssignedTo: ''
        });
    };

    const handleApplyFilters = () => {
        setCurrentPage(1);
        handleClose();
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setCurrentPage(1);
    };

    const getAvatarColor = (title) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = title ? title.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const createSortHandler = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const processedData = useMemo(() => {
        let result = [...data];


        if (filters.Priority) {
            result = result.filter(item => item.priority === filters.Priority);
        }

        if (filters.Status) {
            result = result.filter(item => item.WorkflowStatus === filters.Status);
        }


        if (filters.DueDate) {
            result = result.filter(item =>
                moment(item.DueDate).format('YYYY-MM-DD') === filters.DueDate
            );
        }


        if (filters.AssignedTo) {
            result = result.filter(item =>
                item.Name?.toLowerCase().includes(filters.AssignedTo.toLowerCase())
                // item.assignedTo?.toLowerCase().includes(filters.AssignedTo.toLowerCase())
            );
        }


        if (orderBy) {
            result = [...result].sort((a, b) => {
                const aValue = a[orderBy];
                const bValue = b[orderBy];

                if (orderBy === 'dueDate') {
                    const aDate = new Date(aValue);
                    const bDate = new Date(bValue);
                    return order === 'asc' ? aDate - bDate : bDate - aDate;
                }

                if (typeof aValue === 'string') {
                    return order === 'asc'
                        ? aValue.localeCompare(bValue)
                        : bValue.localeCompare(aValue);
                }

                return order === 'asc' ? aValue - bValue : bValue - aValue;
            });
        }
        return result;
    }, [data, filters, order, orderBy]);

    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return processedData.slice(startIndex, endIndex);
    }, [processedData, currentPage, pageSize]);

    const totalCount = processedData.length;

    const handleViewClick = (row) => {
        setPopupOpen(true)
        setSelectedRowData(row)
    }

    const handleCloseClick = () => {
        setPopupOpen(false)
        setSelectedRowData(null)
    }

    const columns = [
        {
            name: "Task",
            field: "currentStep",
            width: "360px",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Avatar
                        sx={{
                            width: 30,
                            height: 30,
                            bgcolor: getAvatarColor(row.entityType),
                            color: "#fff",
                            fontSize: "14px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                        }}
                    >{row?.entityType?.[0] || "?"}</Avatar>
                    <Link
                        component="button"
                        onClick={() => handleViewClick(row)}
                        sx={{
                            textAlign: 'justify'
                        }}
                    >
                        {row?.currentStep}
                    </Link>
                    {/* <Box>
                            <Typography sx={{
                                fontSize: "16px", maxWidth: "250px", fontWeight: 500, fontFamily: "Outfit", color: "#433F5E", overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}>
                                {row?.currentStep}
                            </Typography>
                        </Box>

                        <Box className="hoverButtons" sx={{ display: "none", gap: "10px" }}>
                            <Button
                                onClick={() => handleViewClick(row)}
                                startIcon={<LuEye style={{ width: 12, height: 12 }} />}
                                sx={{
                                    backgroundColor: "#E7E7EB",
                                    p: "2px 6px",
                                    borderRadius: "5px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    textTransform: 'none'
                                }}
                            >
                                View
                            </Button>
                        </Box> */}
                </Box>
            ),
        },
        {
            name: "Category",
            field: "entityType",
            // width: "10%",
        },
        {
            name: "Status",
            field: "workflowStatus",
            // width: "5%",
            renderer: (row) => (
                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                    <StatusBadge status={row?.workflowStatus} />
                </Box>
            )
        },
        {
            name: "Received On",
            field: "pendingFrom",
            // width: "10%",
            renderer: (row) => (
                <Box sx={{
                    display: "inline-flex",
                    gap: "8px",
                    alignItems: "center",
                    backgroundColor: "#E7E7EB",
                    p: "2px 6px",
                    borderRadius: "5px",
                    width: "auto"
                }}>
                    <CiCalendar size={16} color="#5B5772" />
                    <Typography sx={{
                        color: "#5B5772",
                        fontWeight: 600,
                        fontSize: "12px",
                        lineHeight: "100%",
                        fontFamily: "Outfit, sans-serif",
                    }}>
                        {moment(row.pendingFrom).format("DD MMM YYYY")}
                    </Typography>
                </Box>
            )
        },
        {
            name: "Due Date",
            field: "DueDate",
            // width: "10%",
            renderer: (row) => (
                <Box sx={{
                    display: "inline-flex",
                    gap: "8px",
                    alignItems: "center",
                    backgroundColor: "#E7E7EB",
                    p: "2px 6px",
                    borderRadius: "5px",
                    width: "auto"
                }}>
                    <CiCalendar size={16} color="#5B5772" />
                    <Typography sx={{
                        color: "#5B5772",
                        fontWeight: 600,
                        fontSize: "12px",
                        lineHeight: "100%",
                        fontFamily: "Outfit, sans-serif",
                    }}>
                        {moment(row.DueDate).format("DD MMM YYYY")}
                    </Typography>
                </Box>
            )
        },
        {
            name: "Assigned To",
            field: "name",
            // width: "15%",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
                    <Avatar
                        sx={{
                            bgcolor: getAvatarColor(row.Name),
                            height: "32px",
                            width: "32px",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            textTransform: "uppercase",
                        }}
                    >
                        {row?.name?.[0] || "?"}
                    </Avatar>

                    <Box>
                        <Typography
                            sx={{
                                fontSize: "12px", fontWeight: 400, lineHeight: "155%", color: "#726F86", fontFamily: "Outfit, sans-serif"
                            }}>
                            {row.roleName}
                        </Typography>
                    </Box>
                </Box>
            )
        }
    ];

    return (
        <>
            <Grid size={12}>
                <Grid container>
                    <Grid size={{ md: 8, sm: 6 }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                padding: "8px 0",
                                alignItems: "center",
                                minHeight: "40px"
                            }}
                        >

                            {filters.Priority && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Category:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {workPriority.find(cat => cat.value === filters.Priority)?.label || filters.Priority}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('Priority')}
                                />
                            )}


                            {filters.Status && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Status:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {workStatus.find(status => status.value === filters.Status)?.label || filters.Status}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('Status')}
                                />
                            )}


                            {filters.AssignedTo && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Assigned To:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {filters.AssignedTo}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('AssignedTo')}
                                />
                            )}


                            {filters.DueDate && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Due Date:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {moment(filters.DueDate).format('DD-MM-YYYY')}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('DueDate')}
                                />
                            )}
                        </Stack>
                    </Grid>
                    <Grid size={{ md: 4, sm: 6 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: 'end',
                                p: "8px 0px"
                            }}
                        >
                            <IconButton
                                ref={anchorRef}
                                onClick={handleToggle}
                            >
                                <MdOutlineFilterAlt size={24} color="#48535B" />
                            </IconButton>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                placement="bottom-end"
                                transition
                                disablePortal={false}
                                sx={{ zIndex: 2000 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {({ TransitionProps }) => (
                                    <Grow {...TransitionProps}>
                                        <Paper
                                            sx={{
                                                mt: 1,
                                                p: 2,
                                                borderRadius: 1,
                                                boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                width: 300,
                                            }}
                                        >
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <Box>
                                                    <Grid container spacing={2}>

                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Priority</Typography>
                                                            <Select
                                                                name="Priority"
                                                                options={workPriority}
                                                                placeholder="Select Priority"
                                                                onChange={(option) => handleSelectChange(option, "Priority")}
                                                                value={filters.Priority ? workPriority.find(option => option.value === filters.Priority) : null}
                                                            />

                                                        </Grid>


                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Status</Typography>
                                                            <Select
                                                                name="Status"
                                                                options={workStatus}
                                                                placeholder="Select Status"
                                                                onChange={(option) => handleSelectChange(option, "Status")}
                                                                value={filters.Status ? workStatus.find(option => option.value === filters.Status) : null}

                                                            />
                                                        </Grid>


                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Due Date</Typography>
                                                            <TextField
                                                                type="date"
                                                                name="due_date"
                                                                value={filters.DueDate || ''}
                                                                onChange={(e) => {
                                                                    const selectedDate = e.target.value;
                                                                    setFilters((prev) => ({
                                                                        ...prev,
                                                                        DueDate: selectedDate,
                                                                    }));
                                                                }}
                                                                onClick={(e) => {
                                                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                    if (input) input.showPicker?.();
                                                                }}
                                                                fullWidth
                                                                sx={{
                                                                    "& input::-webkit-calendar-picker-indicator": {
                                                                        display: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& input[type='date']": {
                                                                        appearance: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": {
                                                                            border: "none",
                                                                        },
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                            {calenderSVG}
                                                                        </Box>
                                                                    ),
                                                                    sx: {
                                                                        backgroundColor: "#E7E7EB",
                                                                        height: "40px",
                                                                        width: { xs: "100%", md: "100%" },
                                                                        borderRadius: "5px",
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>


                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Assignee</Typography>
                                                            <TextField
                                                                fullWidth
                                                                name="AssignedTo"
                                                                value={filters.AssignedTo}
                                                                onChange={handleInputChange}
                                                                placeholder="Enter Assignee"
                                                                InputProps={{
                                                                    sx: {
                                                                        height: "40px",
                                                                        borderRadius: "3px",
                                                                        backgroundColor: "#fff",
                                                                        "& input::placeholder": {
                                                                            fontWeight: 400,
                                                                            fontSize: "16px",
                                                                            lineHeight: "100%",
                                                                            letterSpacing: "0.16px",
                                                                            color: "#0A0A0C",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            opacity: 1,
                                                                        },
                                                                        "& input": {
                                                                            fontWeight: 400,
                                                                            fontSize: "16px",
                                                                            lineHeight: "100%",
                                                                            letterSpacing: "0.16px",
                                                                            color: "#0A0A0C",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                        },
                                                                        "& input:-webkit-autofill": {
                                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                            WebkitTextFillColor: "#0A0A0C !important",
                                                                            borderRadius: "3px",
                                                                        },

                                                                        "& input:-webkit-autofill:hover": {
                                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                        },

                                                                        "& input:-webkit-autofill:focus": {
                                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>


                                                        <Grid size={12}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Button onClick={handleReset}
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "#F15744",
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        borderRadius: "25px",
                                                                        fontWeight: 500,
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}>
                                                                    Reset
                                                                </Button>
                                                                <Button
                                                                    type="button"
                                                                    onClick={handleApplyFilters}
                                                                    variant="contained"
                                                                    sx={{
                                                                        backgroundColor: "#00344C",
                                                                        borderRadius: "25px",
                                                                        textTransform: "none",
                                                                        fontWeight: 500,
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        color: "#FFFFFF",
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}
                                                                >
                                                                    Apply
                                                                </Button>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                            <IconButton>
                                <BiListUl size={24} color="#48535B" />
                            </IconButton>
                            <IconButton>
                                <MdOutlineFileDownload size={24} color="#48535B" />
                            </IconButton>
                            <IconButton>
                                <LuRefreshCw size={20} color="#48535B" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            </Grid >
            <TableComponent
                data={paginatedData}
                isLoading={loading}
                columns={columns}
                order={order}
                orderBy={orderBy}
                createSortHandler={createSortHandler}
            />
            <CustomPagination
                totalCount={totalCount}
                pageSize={pageSize}
                page={currentPage}
                onPageChange={handlePageChange}
                setCurrentPage={setCurrentPage}
                onPageSizeChange={handlePageSizeChange}
            />
            <WorkDetail
                open={popupOpen}
                onClose={handleCloseClick}
                cardData={selectedRowData}
            />
        </>
    );
}

export default DueList;
